import request from '../../../axios';

export const deleteChatItem = async (guid?: string, replyGuid?: string) => {
  const {data}: {data: IResponse} = await request.delete(
    `/api/v2/shop/chat/${guid}/messages/${replyGuid}`,
  );
  return data;
};
